import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators
} from "@angular/forms";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { RoutingPath } from "src/app/configs/routing-path";
import { InformationFormatting } from "src/app/core/helpers/information-formatting/information-formatting";
import { RegularExpressions } from "src/app/core/helpers/regular-expressions/regular-expressions";
import { Compania } from "src/app/core/models/afiliate/afilado";
import { CivilStatus } from "src/app/core/models/enum/civil-status.enum";
import { TipoSolicitudComplementoEnum } from "src/app/core/models/enum/tipo-solicitud-complemento.enum";
import { ConyugeModel } from "src/app/core/models/request/afiliaciones/conyuge.model";
import { SolicitudTiposEnum } from "src/app/core/models/request/afiliaciones/solicitud-tipos.enum";
import { Afiliate } from "src/app/core/models/request/afiliate";
import { ParametrosSolicitudValida } from "src/app/core/models/request/parametros-solicitud-valida";
import { Content, Request } from "src/app/core/models/request/request";
import { Conyuge, SolicitudAfiliacionObsoleta } from "src/app/core/models/request/solicitud-afiliacion-obsoleta";
import { SolicitudCambioEstadoCivil } from "src/app/core/models/request/solicitud-cambio-estado-civil";
import { BodyRequestValid } from "src/app/core/models/request/solicitud-valida";
import { ApiCambioEstadoCivilInterface } from "src/app/core/models/response/api-cambio-estado-civil.interface";
import { IUser } from "src/app/core/models/user/user";
import { Pac, WresponseData } from "src/app/core/models/worker/wresponse-data";
import { AffiliationService } from "src/app/core/services/affiliation/affiliation.service";
import { DisaffiliationService } from "src/app/core/services/disaffiliation/disaffiliation.service";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { ModalService } from "src/app/core/services/modal/modal.service";
import { ObligatoriedadDocumentosService } from "src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { RequestService } from "src/app/core/services/request/request.service";
import { ValidateData } from "src/app/core/utils/validate-data";
import { environment } from "src/environments/environment";
import { Empresa } from "../../../core/models/request/afiliaciones/empresa.model";
import { RadicacionSolicitudService } from "../../../core/services/api/radicacion-solicitud.service";
import { DialogoConfirmacionComponent } from "../../common/dialogo-confirmacion/dialogo-confirmacion.component";
import { StatusRequest, TypeRequest } from "../../common/form-dynamic/enum";
import { ParentescosService } from "../../individual-affiliation/pages/affiliation-form/services/parentescos.service";

@Component({
  selector: "app-seleccionar-nuevo-estado",
  templateUrl: "./seleccionar-nuevo-estado.component.html",
  styleUrls: ["./seleccionar-nuevo-estado.component.scss"],
})
export class SeleccionarNuevoEstadoComponent implements OnInit {
  empresaFromStorage: string;
  empresaData: any;
  nuevoEstadoCivilFormulario: FormGroup;
  form: FormGroup;
  documentosListos = false;
  idModal = "m-estado";
  tieneEstadoCivil: { codigo: string; desc: string };
  estados = [];
  finalizaRequestSvc: boolean = false;
  deshabilitarCambioEstadoCivil: boolean = false;
  estadoCivilActual: string;
  private datosUsuarioLogueado: IUser = this._storage.parseItem<IUser>(
    environment.LOCAL_STORAGE.USER_LOGGED_IN
  );
  public idModalLoad = "m-load";
  private ACM: Boolean = false;
  public dateFormat = new DatePipe("es-CO");
  reglasCambioEstadoCivil: any;
  public dataJson: any;
  public dataJsonBuilForm: any;
  private datosAfiliadoMapeado: Afiliate;
  private datosAfiliado: WresponseData = this._storage.parseItem<WresponseData>(
    environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION
  );
  private datosAfiliadoCompania: Compania = this._storage.parseItem<Compania>(
    environment.LOCAL_STORAGE.BUSINESS_INFORMATION
  );
  private reasonSeleccionado: ApiCambioEstadoCivilInterface;
  public datosConyuge: Pac = null;
  idRequestType: number = TypeRequest.EstadoCivil;
  private caso1: { codigo: string; desc: string }[] = [
    { codigo: CivilStatus.MARRIED.codigo, desc: CivilStatus.MARRIED.desc },
    {
      codigo: CivilStatus.FREE_UNION.codigo,
      desc: CivilStatus.FREE_UNION.desc,
    },
  ];
  private caso2: { codigo: string; desc: string }[] = [
    { codigo: CivilStatus.SEPARATED.codigo, desc: CivilStatus.SEPARATED.desc },
    { codigo: CivilStatus.WIDOWER.codigo, desc: CivilStatus.WIDOWER.desc },
    { codigo: CivilStatus.MARRIED.codigo, desc: CivilStatus.MARRIED.desc },
    {
      codigo: CivilStatus.FREE_UNION.codigo,
      desc: CivilStatus.FREE_UNION.desc,
    },
  ];
  private filtrarEstadosCiviles: {
    [x: string]: { codigo: string; desc: string }[];
  } = {
    [CivilStatus.SINGLE.codigo]: this.caso1,
    [CivilStatus.SEPARATED.codigo]: this.caso1,
    [CivilStatus.WIDOWER.codigo]: this.caso1,
    [CivilStatus.MARRIED.codigo]: this.caso2,
    [CivilStatus.FREE_UNION.codigo]: this.caso2,
  };
  private afiliacion: SolicitudAfiliacionObsoleta;
  workerData: WresponseData;
  errorSolicitud: boolean;
  private estadosValidos: number[] = [
    StatusRequest.proceso,
    StatusRequest.rechazado,
  ];
  OcupacionConyuge: string;
  respuestaRetiro: any;

  constructor(
    private fb: FormBuilder,
    private _MODAL: ModalService,
    private dialog: MatDialog,
    private _storage: LocalStorageService,
    private affiliationService: AffiliationService,
    private parentescosService: ParentescosService,
    private disaffiliationService: DisaffiliationService,
    private requestSvc: RequestService,
    private router: Router,
    private _ObligatoriedadDocumentosService: ObligatoriedadDocumentosService,
    private cambioEstadoCivilService: RadicacionSolicitudService
  ) {}

  ngOnInit() {
    this.errorSolicitud = false;
    this.workerData = this._storage.getItemJSON(environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION);
    this.iniciarFormulario();
    this.validarEstadoCivil();
    this.capturarDatosDeSolicitud();
    this.obtenerInfoEmpresa();
  }

  iniciarFormulario() {
    this.nuevoEstadoCivilFormulario = this.fb.group({
      estadoCivil: [null, [Validators.required]],
    });

    this.form = this.fb.group({
      reason: [null, Validators.required],
      estadoCivil: [null, [Validators.required]],
    });
  }

  formConyugeBuild() {
    return this.fb.group({
      TipoIdConyuge: [{ value: null }, [Validators.required]],
      tipoDocumentoObjeto: [{ value: null }],
      NumIdConyuge: ["", [Validators.required]],
      Apellido1Conyuge: [
        "",
        [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern(RegularExpressions.ONLY_LETTERS_ESPECIAL_CHARTS),
        ],
      ],
      Apellido2Conyuge: [
        "",
        [
          Validators.minLength(2),
          Validators.pattern(RegularExpressions.ONLY_LETTERS_ESPECIAL_CHARTS),
        ],
      ],
      Nombre1Conyuge: [
        "",
        [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern(RegularExpressions.ONLY_LETTERS_ESPECIAL_CHARTS),
        ],
      ],
      Nombre2Conyuge: [
        "",
        [
          Validators.minLength(2),
          Validators.pattern(RegularExpressions.ONLY_LETTERS_ESPECIAL_CHARTS),
        ],
      ],
      FechaNaciConyuge: ["", [Validators.required]],
      GeneroConyuge: ["", [Validators.required]],
      OcupacionConyuge: ["", [Validators.required]],
      TipoIdEmpresaConyuge: ["", []],
      NumIdEmpresaConyuge: ["", []],
      DigVerEmpresaConyuge: ["", []],
      RazonEmpresaConyuge: ["", []],
      TipoSalarioConyuge: ["", []],
      SalarioConyuge: ["", []],
      CuidadorConyuge: ["", []],
    });
  }

  validarEstadoCivil() {
    const estadoCivil = JSON.parse(localStorage.getItem("workerInformation"));
    this.estadoCivilActual =
      estadoCivil.validacion_afiliado.afiliado.estadoCivil;

    if (this.estadoCivilActual === CivilStatus.MARRIED.codigo) {
      this.estados = this.filtrarEstadosCiviles[this.estadoCivilActual].filter(
        (est) =>
          est.codigo !== this.estadoCivilActual &&
          est.codigo !== CivilStatus.FREE_UNION.codigo
      );
    }

    this.estados = this.filtrarEstadosCiviles[this.estadoCivilActual].filter(
      (est) => est.codigo !== this.estadoCivilActual
    );
  }

  cambioEstado() {
    let estadoCivilForm = this.form.get("estadoCivil").value;

    if (
      estadoCivilForm["codigo"] === CivilStatus.FREE_UNION.codigo &&
      this.estadoCivilActual === CivilStatus.MARRIED.codigo
    ) {
      this.estados = this.estados.filter(
        (est) => est.codigo !== CivilStatus.FREE_UNION.codigo
      );
      this.form.get("estadoCivil").setValue("");
    } else {
      this.tieneEstadoCivil = estadoCivilForm;

      this.reglasCambioEstadoCivil = this.reglasEstadoCivil(
        this.estadoCivilActual,
        this.tieneEstadoCivil
      );

      this.form.get("reason").setValue(this.reglasCambioEstadoCivil.idJson);
      this.form.addControl("conyuge", this.formConyugeBuild());
      this.deshabilitarCambioEstadoCivil = true;
      this.form.get("estadoCivil").disable();
    }
  }

  recibirFuncionRegresar() {
    this.form.get("conyuge").reset();
    this.form.get("conyuge").updateValueAndValidity();
    this.form.get("estadoCivil").enable();
    this.form.get("estadoCivil").setValue(null);
    this.form.get("reason").setValue(null);
    this.tieneEstadoCivil = null;
    this.deshabilitarCambioEstadoCivil = false;
    this.documentosListos = false;
  }

  mostrarDialogoSubmit() {
    let textoModal = `Para poder realizar el cambio de estado civil a <strong>${CivilStatus.MARRIED.desc}</strong> y afiliar la nueva pareja de tu empleado, debes realizar primero el cambio de estado civil a <strong>${CivilStatus.SEPARATED.desc}.</strong> El proceso de cambio de estado civil y afiliación de la nueva pareja puede tardar hasta 24 horas.`;
    const objetoTaggeo = {
      event: "ga_event",
      category: "PTEC_estado_civil",
      action: "aceptar",
      label: "cambio_estado_civil",
    };
    if (this.form.valid) {
      let config = new MatDialogConfig();
      config.viewContainerRef = null;
      config.disableClose = true;
      config.role = "alertdialog";
      config.width = "471px";
      config.data = {
        label: this.form.get("conyuge").valid
          ? textoModal
          : "¿Estás seguro que la información ingresada es correcta?",
        botones: { cancelar: "Cancelar", enviar: "Aceptar" },
        taggeo: objetoTaggeo,
      };
      this.dialog
        .open(DialogoConfirmacionComponent, config)
        .afterClosed()
        .subscribe((confirmado: Boolean) => {
          if (confirmado) {
            this.mapearDatosAfiliacion();
            !this.form.valid ? this.regresarEstado() : this.submit();
          }
        });
    }
  }

  regresarEstado() {
    this.form.reset();
  }

  get formConyuge() {
    return this.form.get("conyuge") as FormGroup;
  }

  private mapTrabajador(obj) {
    let horasMen = parseInt(`${obj["afiliacion"]["horasLaboradas"]}`) * 30;
    return {
      SucursalTrabajador: "",
      TipoIdTrabajador: obj["tipoDocumento"],
      NumIdTrabajador: obj["numeroDocumento"],
      Apellido1Trabajador: obj["primerApellido"],
      Apellido2Trabajador: obj["segundoApellido"] || "",
      Nombre1Trabajador: obj["primerNombre"],
      Nombre2Trabajador: obj["segundoNombre"] || "",
      FechaNaciTrabajador: obj["fechaNacimiento"].split("T")[0],
      EdadTrabajador: obj["edad"],
      EmailTrabajador: obj["correoElectronico"] !== "null" ? obj["correoElectronico"] : "noexisteEnelvalidador@colsubsidio.com",
      EstadoCivilTrabajador: {
        codigo: obj["estadoCivil"],
        desc: obj["estadoCivil"] === "1" ? "Soltero/a" : "Casado/a"
      },
      GeneroTrabajador: obj["genero"],
      FechaIngresoTrabajador: obj["afiliacion"]["fechaAfiliacion"].split("T")[0],
      HorasLabDiaTrabajador: obj["afiliacion"]["horasLaboradas"],
      SalarioTrabajador: obj["afiliacion"]["salario"],
      DireccionResTrabajador: obj["direccion"]["direccionPrincipal"],
      DepartamentoResTrabajador: {
        department_DESC: obj["direccion"]["departamento"]["nombre"],
        department_CODE: obj["direccion"]["departamento"]["id"]
      },
      CiudadResTrabajador: {
        department_CODE: obj["direccion"]["departamento"]["id"],
        municipality_DESC: obj["direccion"]["ciudad"]["nombre"],
        municipality_CODE: obj["direccion"]["ciudad"]["id"]
      },
      TelefonoResTrabajador: obj["telefono"],
      AutEmailTrabajador: "Si",
      TelefonoCelTrabajador: "3009999999",
      HorasLabMesTrabajador: horasMen,
      TipSalarioTrabajador: obj["afiliacion"]["tipoSalario"],
      TipoActTrabajador: obj["afiliacion"]["tipoCargo"],
      TipoContraTrabajador: "01",
      NacionalidadTrabajador: {
        id: 48,
        nationality_DESC: "Colombia",
        nationality_SAP: "CO"
      },
      EsValido: true,
      documents: {          
      },
      beneficiariosACM: this.ACM ? 1 : 0,
      beneficiariosAFI: 1
    }
  }


  submit(): void {
    const dataFrom = this.form.value;
    this.form.clearAsyncValidators();
    delete this.reasonSeleccionado.active;
    delete this.reasonSeleccionado.documents;

    const cellPhone =
      this.datosUsuarioLogueado.telephoneNumber &&
      this.datosUsuarioLogueado.telephoneNumber !== "0"
        ? this.datosUsuarioLogueado.telephoneNumber
        : this.datosAfiliado.validacion_afiliado.afiliado.telefono;
    const codVer = this.datosUsuarioLogueado.checkDigit;
    const email = this.datosUsuarioLogueado.email;

    this.afiliacion.trabajador.EmailTrabajador = email;
    this.afiliacion.empleador.digVerifEmpleador = codVer;

    const conyugeForm = this.formConyuge.getRawValue();
    this.afiliacion.conyuge = Conyuge.conyugeDesdeObjConyuge(conyugeForm);
    const pac: Pac = this.builderPacConyuge(this.afiliacion.conyuge);

    const date = new Date();
    const dateFormat = this.dateFormat.transform(date, "yyyy-MM-dd");

    const content: Content = this.reglasCambioEstadoCivil.tieneInformacionAdicional
      ? this.contentParaAfiliarConyuge(dateFormat, pac, codVer, cellPhone, email)
      : this.contentParaCambioEstadoCivil(dateFormat, pac, codVer, cellPhone, email);

    const contentAux = JSON.stringify(content);

    const request: Request = {
      code: null,
      typeDocument: this.datosAfiliadoMapeado.docType,
      numberDocument: this.datosAfiliadoMapeado.docNumber,
      typeDocumentBusiness: this.datosAfiliadoCompania.tipoDocumento,
      numberDocumentBusiness: this.datosUsuarioLogueado.docNumberCompany,
      state: 1,
      type: this.idRequestType,
      content: "",
      portal: 2,
    };

    const formData = new FormData();
    formData.set("body", JSON.stringify(request));
    formData.set("content", contentAux);

    this.datosAfiliado.validacion_afiliado.afiliado.estadoCivil = this.reasonSeleccionado.idNuevoEstadoCivil;
    const documentosForm = this.form.get("documents")?.value || {};
    this.finalizarEnvio(documentosForm);
  }

  finalizarEnvio(documentosForm: any): void {
    const formAfiliadoModel = this.mapTrabajador(this.datosAfiliado.validacion_afiliado.afiliado);
    const empresaModelData = this.empresaData;
    const conyugeMap = this.form.controls.conyuge.value;
    const documentMap = {
      ...this.form.value,
      documents: documentosForm
    };
    const cambioEstadoCivil = this.form.controls.reason.value
    const formularioConyugeModel = ConyugeModel.mapearDesdeFormularioCEC(
      conyugeMap,
      documentMap,
      cambioEstadoCivil
    );
    const formEmpresaModel = Empresa.empleadorDesdeObjCEC(empresaModelData, this.datosUsuarioLogueado.docNumberCompany, this.datosUsuarioLogueado.checkDigit);
    const solicitudCambioEstadoCivil = SolicitudCambioEstadoCivil.mapearDesdeFormularioCEC(
      formAfiliadoModel,
      formularioConyugeModel,
      formEmpresaModel
    );
    this.cambioEstadoCivilService.crearRadicacionSolicitudes(solicitudCambioEstadoCivil).subscribe(
      data => {
        this.respuestaRetiro = data?.resultado[0];
      },
      error => {
        console.log(error);
      }
    );
  }

  private radicarSolicitudCEC(affiliate: SolicitudCambioEstadoCivil) {
    this.affiliationService.createAffiliation(affiliate)
      .pipe(
        map(response => this.handleAffiliationResponse(response)),
        catchError(err => this.handleAffiliationError(err))
      )
      .subscribe();
  }

  private handleAffiliationError(err: any) {
    this.router.navigate([this.getErrorUrl()]);
    return throwError(err);
  }

  private getErrorUrl() {
    return "/" + RoutingPath.appRouting.components.invidivual_affiliation.path + "/" +
      RoutingPath.appRouting.components.invidivual_affiliation.pages.error_affiliation.path;
  }

  private handleAffiliationResponse(response: any) {
    let url = this.constructUrl(response);
    this._storage.removeItem(environment.LOCAL_STORAGE.DATA_AFILIACION_USUARIO);
    this.router.navigate([url]);
  }

  private constructUrl(response: any) {
    let url = "/" + RoutingPath.appRouting.components.workers_information.path;
    const resultado = response.resultado[0];
    if (resultado && resultado.exitoso && resultado.codigo === 200) {
      const radicado = resultado.radicado ? resultado.radicado : "";
      const usuario = resultado.transaccion[0].usuario;
      if (usuario) {
        url += "/" + RoutingPath.appRouting.components.workers_information.pages.civil_status_change.path + "/";
        url += "/" + RoutingPath.appRouting.components.workers_information.pages.civil_status_change.children.success.path;
      }
    } else {
      this._storage.stringifyItem("ErroresFormularioAfiliacion", resultado ? resultado.errores : "Error desconocido");
      url += "/" + RoutingPath.appRouting.components.invidivual_affiliation.pages.error_affiliation.path;
    }
    return url;
  }

  builderPacConyuge(conyuge: Conyuge): Pac {
    const pac = {} as Pac;

    pac.tipoDocumento = this.formConyuge.get("TipoIdConyuge").value;
    pac.numeroDocumento = conyuge.NumIdConyuge;
    pac.primerNombre = conyuge.Nombre1Conyuge;
    pac.segundoNombre = conyuge.Nombre2Conyuge;
    pac.apellido = conyuge.Apellido1Conyuge;
    pac.segundoApellido = conyuge.Apellido2Conyuge;
    pac.fechaNacimiento = conyuge.FechaNaciConyuge;
    pac.genero = this.formConyuge.get("GeneroConyuge").value;

    pac.relacion = {
      codigo: "5",
      descripcion: "Conyuge",
    };

    return pac;
  }

  contentParaCambioEstadoCivil(dateFormat, pac, codVer, cellPhone, email) {
    this.form.clearAsyncValidators();
    this.idRequestType = TypeRequest.EstadoCivil;

    this.datosAfiliadoMapeado.maritalStatus = this.tieneEstadoCivil.codigo;
    this.datosAfiliadoMapeado.birthDate = this.dateFormat.transform(
      this.datosAfiliadoMapeado.birthDate,
      "yyyyMMdd"
    );

    let content: Content = {
      reasonType: {
        id: this.reasonSeleccionado.idNuevoEstadoCivil,
        name: this.reasonSeleccionado.name,
      },
      pac: { ...pac, discapacidad: "" },
      fechaSolicitud: dateFormat,
      afiliate: this.datosAfiliadoMapeado,
      digitoVerificador: String(codVer),
      contact: {
        cellPhone: cellPhone,
        email: email,
        ciudad: InformationFormatting.returnNameCity(this.workerData.validacion_afiliado.afiliado.direccion.ciudad.id),
        departamento: InformationFormatting.returnDepartment(this.workerData.validacion_afiliado.afiliado.direccion.departamento.id),
      },
    };

    return content;
  }

  contentParaAfiliarConyuge(dateFormat, pac, codVer, cellPhone, email) {
    this.idRequestType = TypeRequest.AfiliateBeneficiary;

    this.datosAfiliadoMapeado.birthDate = this.dateFormat.transform(
      this.datosAfiliadoMapeado.birthDate,
      "yyyyMMdd",
      "+0100"
    );

    this.afiliacion.trabajador.FechaNaciTrabajador = this.dateFormat.transform(
      this.afiliacion.trabajador.FechaNaciTrabajador,
      "yyyyMMdd",
      "+0100"
    );

    this.afiliacion.trabajador.FechaIngresoTrabajador =
      this.dateFormat.transform(
        this.afiliacion.trabajador.FechaIngresoTrabajador,
        "yyyyMMdd",
        "+0100"
      );

    if (this.afiliacion.conyuge) {
      const tipoSalario = this.formConyuge.get("TipoSalarioConyuge").value;
      this.afiliacion.conyuge.TipoSalarioConyuge =
        InformationFormatting.returnNameSalaryType(tipoSalario);
      this.afiliacion.conyuge.SalarioConyuge =
        this.formConyuge.get("SalarioConyuge").value;
      this.afiliacion.conyuge.FechaNaciConyuge = this.dateFormat.transform(
        this.afiliacion.conyuge.FechaNaciConyuge,
        "yyyyMMdd",
        "+0100"
      );
    }

    this.afiliacion.trabajador.TelefonoCelTrabajador = "3189913040";
    this.afiliacion.empleador.idEmpleador =
      this.datosUsuarioLogueado.docNumberCompany;
    let content: Content = {
      reasonType: {
        id: this.reasonSeleccionado.idNuevoEstadoCivil,
        name: this.reasonSeleccionado.name,
      },
      fechaSolicitud: dateFormat,
      pac: {
        ...pac,
        discapacidad: "",
      },
      afiliate: this.datosAfiliadoMapeado,
      digitoVerificador: String(codVer),
      contact: {
        cellPhone: cellPhone,
        email: email,
        ciudad: InformationFormatting.returnNameCity(this.workerData.validacion_afiliado.afiliado.direccion.ciudad.id),
        departamento: InformationFormatting.returnDepartment(this.workerData.validacion_afiliado.afiliado.direccion.departamento.id),
        // email: 'edwin.chavarrotr@colsubsidio.com',
      },
      afiliacion: this.afiliacion,
      ACM: this.ACM,
      cambioEstadoCivil: true,
    };

    return content;
  }

  private mapearDatosAfiliacion() {
    let filterConyuge = this.datosAfiliado.validacion_afiliado.pacs.filter(
      (x) => x.relacion.codigo === "SUB-0002"
    );

    if (filterConyuge.length > 0) {
      this.datosConyuge = filterConyuge[0];
    }

    this.datosAfiliado.validacion_afiliado.afiliado.estadoCivil =
      this.reasonSeleccionado.idNuevoEstadoCivil;

    this.afiliacion = SolicitudAfiliacionObsoleta.afiliacionDesdeObj(
      this.datosAfiliado.validacion_afiliado.afiliado,
      this.datosAfiliadoCompania,
      this.datosConyuge
    );

    this.datosAfiliadoMapeado = Afiliate.afiliateDesdeObj(
      this.datosAfiliado.validacion_afiliado.afiliado
    );
  }

  mostrarDialogo() {
    this.form.enable();
    if (this.form.get("estadoCivil").valid) {
      let config = new MatDialogConfig();
      config.viewContainerRef = null;
      config.disableClose = true;
      config.role = "alertdialog";
      config.width = "471px";
      config.data = {
        label: this.obtenerEtiquetaModal(),
        botones: { cancelar: "Cancelar", enviar: "Aceptar" },
      };
      this.dialog
        .open(DialogoConfirmacionComponent, config)
        .afterClosed()
        .subscribe((confirmado: Boolean) => {
          if (confirmado) {
            this.requestSvc.getReasons(this.idRequestType).then((data) => {
              if (data.reason) {
                this.dataJson = data;
                this.cambioEstado();
                this.reasonSeleccionado = this.dataJson.reason.find(
                  (element) => element.id == this.form.get("reason").value
                );
                this.finalizaRequestSvc = true;
              }
            });
          }
        });
    }
  }

  private obtenerEtiquetaModal(): string {
    let estadoCivilSeleccionado: { codigo: string; desc: string } | null =
      this.form.get("estadoCivil").value;
    return this.reglasEstadoCivil(
      this.estadoCivilActual,
      estadoCivilSeleccionado
    ).textoModalSeleccionado;
  }

  capturarDatosDeSolicitud() {
    const params: ParametrosSolicitudValida = new ParametrosSolicitudValida();
    params.affiliateDocument =
      this.workerData.validacion_afiliado.afiliado.numeroDocumento;
    params.affiliateTypeDocument =
      this.workerData.validacion_afiliado.afiliado.tipoDocumento;
    params.type = TipoSolicitudComplementoEnum.ESTADO_CIVIL;

    this.disaffiliationService.getDataRequestValid(params).subscribe(
      (res) => {
        const solicitudes = !ValidateData.emptyObject(res.body)
          ? res.body
          : new Array<BodyRequestValid>();
        this.errorSolicitud =
          solicitudes.length > 0 &&
          solicitudes.filter((solicitud) =>
            this.estadosValidos.some((estado) => estado == solicitud.status)
          ).length > 0;

        if (this.errorSolicitud) {
          this._MODAL.openModal("info");
        }
      },
      (error) => {
        console.error("error caught in component error: " + error.message);
      }
    );
  }

  /**
   * Función para obtener validaciones y valores según flujo de cambio de estado civil
   * @param estadoActual del afiliado
   * @param estadoCivilSeleccionado estado civil seleccionado nuevo en el formulario
   */
  reglasEstadoCivil(estadoActual, estadoCivilSeleccionado) {
    const estadosCivilesConPareja_SinPareja = `Vas a realizar el cambio de estado civil a <strong> ${estadoCivilSeleccionado.desc}. </strong> Ten en cuenta que, para realizar este proceso deberás adjuntar los documentos requeridos y el beneficiario de tipo cónyuge será retirado de la lista de beneficiarios de tu empleado.`;
    const estadosCivilesSinPareja_ConPareja = `Vas a realizar el cambio de estado civil a <strong> ${estadoCivilSeleccionado.desc}. </strong> A continuación, ingresa los datos de el cónyuge de tu empleado y en caso de ser necesario, adjunta los documentos.`;
    const estadoCivilesSinPareja_UnionLibre = `Vas a realizar el cambio de estado civil a <strong> ${estadoCivilSeleccionado.desc}. </strong> A continuación, ingresa los datos de tu cónyuge y en caso de ser necesario, adjunta los documentos.`;
    let regla = {
      // estado actual
      [CivilStatus.UNDEFINED.codigo]: {
        // estado seleccionado desde formulario
        //estado civil casado
        [CivilStatus.MARRIED.codigo]: {
          idJson: "1",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: `Vas a realizar el cambio de estado civil a <strong> ${estadoCivilSeleccionado.desc}. </strong> A continuación, verifica los datos de el cónyuge de tu empleado y en caso de ser necesario, adjunta los documentos.`,
        },
        [CivilStatus.SINGLE.codigo]: {
          idJson: "2",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesSinPareja_ConPareja,
        },
        [CivilStatus.FREE_UNION.codigo]: {
          idJson: "3",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadoCivilesSinPareja_UnionLibre,
        },
        [CivilStatus.SEPARATED.codigo]: {
          idJson: "4",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesConPareja_SinPareja,
        },
        // Estado civil viudo
        [CivilStatus.WIDOWER.codigo]: {
          idJson: "5",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesConPareja_SinPareja,
        },
      },
      [CivilStatus.FREE_UNION.codigo]: {
        // estado seleccionado desde formulario
        [CivilStatus.SEPARATED.codigo]: {
          idJson: "4",
          tieneInformacionAdicional: false,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesConPareja_SinPareja,
        },
        //estado civil casado
        [CivilStatus.MARRIED.codigo]: {
          idJson: "1",
          tieneInformacionAdicional: false,
          tieneSeccionRadioButton: true,
          textoModalSeleccionado: `Vas a realizar el cambio de estado civil a <strong> ${estadoCivilSeleccionado.desc}. </strong> A continuación, verifica los datos de el cónyuge de tu empleado y en caso de ser necesario, adjunta los documentos.`,
        },
        // Estado civil viudo
        [CivilStatus.WIDOWER.codigo]: {
          idJson: "5",
          tieneInformacionAdicional: false,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesConPareja_SinPareja,
        },
      },
      [CivilStatus.MARRIED.codigo]: {
        [CivilStatus.SEPARATED.codigo]: {
          idJson: "4",
          tieneInformacionAdicional: false,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesConPareja_SinPareja,
        },
        [CivilStatus.WIDOWER.codigo]: {
          idJson: "5",
          tieneInformacionAdicional: false,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesConPareja_SinPareja,
        },
        [CivilStatus.FREE_UNION.codigo]: {
          textoModalSeleccionado: `Para poder realizar un cambio de estado civil a <strong> ${estadoCivilSeleccionado.desc} </strong> y afiliar la nueva pareja de tu empleado, debes realizar primero el cambio de estado civil a <strong>${CivilStatus.SEPARATED.desc}. </strong> El proceso de cambio de estado civil y afiliación de la nueva pareja puede tardar hasta 24 horas.`,
        },
      },
      [CivilStatus.SEPARATED.codigo]: {
        [CivilStatus.MARRIED.codigo]: {
          idJson: "2",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesSinPareja_ConPareja,
        },
        [CivilStatus.FREE_UNION.codigo]: {
          idJson: "3",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadoCivilesSinPareja_UnionLibre,
        },
      },
      [CivilStatus.SINGLE.codigo]: {
        [CivilStatus.MARRIED.codigo]: {
          idJson: "2",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesSinPareja_ConPareja,
        },
        [CivilStatus.FREE_UNION.codigo]: {
          idJson: "3",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadoCivilesSinPareja_UnionLibre,
        },
      },
      [CivilStatus.WIDOWER.codigo]: {
        [CivilStatus.MARRIED.codigo]: {
          idJson: "2",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadosCivilesSinPareja_ConPareja,
        },
        [CivilStatus.FREE_UNION.codigo]: {
          idJson: "3",
          tieneInformacionAdicional: true,
          tieneSeccionRadioButton: false,
          textoModalSeleccionado: estadoCivilesSinPareja_UnionLibre,
        },
      },
    };
    return regla[estadoActual][estadoCivilSeleccionado.codigo];
  }

  get idMotivoSolicitud() {
    return this.tieneEstadoCivil.codigo;
  }

  get deshabilitarBtnBuscarPersona() {
    return (
      this.form.invalid && CivilStatus.STATUS_ABLE_RNEC(this.idMotivoSolicitud)
    );
  }
  async validarConyuge(personaControl: FormGroup, tipoPersona: string) {
    const beneficiario = personaControl.getRawValue();
    const datosAdicionales = {
      trabajador: this.afiliacion?.trabajador,
      solicitudId: SolicitudTiposEnum.CEC,
      ocupacionConyuge: beneficiario.conyuge.OcupacionConyuge ?? "01",
      cm: false
    };
    this.documentosListos = false;
    this.dataJsonBuilForm = [];
    try {
      await this.parentescosService.obtenerDocumentosPorParentesco(
        personaControl,
        tipoPersona,
        datosAdicionales
      );
    } catch (error) {
      console.log(error);
    }
    this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject$
      .subscribe(documentosListos => {
        if (!this.documentosListos) {
          this.documentosListos = documentosListos;
        }
      });
    if (!this.documentosListos) {
      this._ObligatoriedadDocumentosService.documentosConyuge$
        .subscribe(docs => {
          this.dataJsonBuilForm = docs;
        });
    }
  }

  obtenerInfoEmpresa() {
    this.empresaFromStorage = localStorage.getItem(environment.LOCAL_STORAGE.BUSINESS_INFORMATION);
    this.empresaData = JSON.parse(this.empresaFromStorage);
  }
}
